<header class="topbar">
  <div class="topbar-wrapper">
    <button
      class="navigation-toggle"
      data-toggles='{".navigation-toggle":"is--active",".navigation":"is--active",".navigation-overlay":"is--active","body":["is--navigation-open","disable-scrolling"]}'
      data-toggles-event="toggle-scrolling"
    >
      <span></span>
      <div class="toggle-title">Menu</div>
    </button>
    <div class="topbar-controls">
      <ng-container *ngIf="$isAdmin | async">
        <a *ngIf="urls.edit" [routerLink]="urls.edit" class="button type-icon-only">
          <span class="icon is--icon-edit">
            <svg class="icon-svg">
              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-edit"></use>
            </svg>
          </span>
          Edit
        </a>
        <button *ngIf="urls.add" class="button type-icon-only" [routerLink]="urls.add">
          add project
          <span class="icon is--icon-plus">
            <svg class="icon-svg">
              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
            </svg>
          </span>
        </button>
      </ng-container>

      <button *ngIf="urls.close" [routerLink]="urls.close" class="button type-icon-only">
        <span class="icon is--icon-close">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-close"></use>
          </svg>
        </span>
        Close
      </button>
    </div>

    <a *ngIf="urls.back" [href]="urls.back" class="button topbar-back">
      <span class="icon is--icon-edit">
        <svg class="icon-svg">
          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-left"></use>
        </svg>
      </span>
      Back
    </a>

    <a *ngIf="urls.intranet" [href]="urls.intranet" class="button topbar-back">
      <span class="icon is--icon-edit">
        <svg class="icon-svg">
          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-left"></use>
        </svg>
      </span>
      Back to Intranet
    </a>

    <h1 class="logo">
      <a routerLink="/projects">
        <span class="icon is--logo-mvrdv">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#logo-mvrdv-horizontal"></use>
          </svg>
        </span>
        MVRDV
      </a>
    </h1>
  </div>
</header>

<div class="app">
  <router-outlet></router-outlet>
</div>
